import React from "react";
import { Container, Paper } from "@mantine/core";

const ContactUsPage = () => {
  return (
    <Container size="md">
      <Paper padding="lg">
        <h1 style={{ textAlign: "center" }}>Contact Us</h1>
        <p>
          We value your feedback, questions, and suggestions. If you have any
          inquiries or need assistance regarding our data-donation service or
          research project, please don't hesitate to reach out to us. We are
          here to help and provide any information you may need.
        </p>

        <h3>Contact Information</h3>
        <p>You can contact us using the following methods:</p>

        <ul>
          <li>
            Email: <a href="mailto:info@example.com">info@example.com</a>
          </li>
          <li>Phone: [+1 (XXX) XXX-XXXX]</li>
        </ul>

        <h3>Office Address</h3>
        <p>
          [Your Organization Name]
          <br />
          [Street Address]
          <br />
          [City, State, Zip Code]
          <br />
          [Country]
        </p>

        <h3>Office Hours</h3>
        <p>
          Our office hours are [Office Hours]. Feel free to contact us during
          these hours, and we will be happy to assist you.
        </p>

        <h3>Connect With Us</h3>
        <p>
          Follow us on social media to stay updated on our latest research
          findings and project updates:
        </p>

        <ul>
          <li>
            Twitter:{" "}
            <a href="https://twitter.com/example">twitter.com/example</a>
          </li>
          <li>
            Facebook:{" "}
            <a href="https://facebook.com/example">facebook.com/example</a>
          </li>
          <li>
            LinkedIn:{" "}
            <a href="https://linkedin.com/company/example">
              linkedin.com/company/example
            </a>
          </li>
        </ul>

        <p>
          Thank you for your interest in our data-donation project. We value
          your support and engagement, and we look forward to hearing from you!
        </p>
      </Paper>
    </Container>
  );
};

export default ContactUsPage;
